import { useMemo, memo, useCallback } from 'react';
import { View } from 'foundations-components/components/View';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
// @ts-expect-error no typings
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isUninitialized, isLoading, getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getHubSpotCallingEnabled } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import CallNumberSkeletons from './CallNumberSkeletons';
import GlobalCallingDisabled from './GlobalCallingDisabled';
import UnlockCallingItem from 'calling-orchestration-shared-library/unlock-calling/components/UnlockCallingItem';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { KB_URL_MANAGE_SEATS } from 'calling-orchestration-shared-library/constants/externalUrls';
import { hasPaidSeatAccess } from 'calling-orchestration-shared-library/hub-info/utils/hasCallingFeature';
import { hasCallingMinutesPerPortal } from 'calling-orchestration-shared-library/hub-info/utils/getCallingLimits';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
function CallingOnboardingWorkspace({
  appIdentifier,
  asyncSettingsOmnibus,
  children
}) {
  const isOmnibusDataUninitialized = isUninitialized(asyncSettingsOmnibus);
  const isOmnibusDataLoading = isLoading(asyncSettingsOmnibus);
  const omnibusData = getData(asyncSettingsOmnibus);
  const shouldShowCallingDisabled = useMemo(() => !getHubSpotCallingEnabled(omnibusData), [omnibusData]);
  const handleTracking = useCallback(() => {
    CommunicatorLogger.log('calling_callUpgradeClicked', {
      source: appIdentifier
    });
  }, [appIdentifier]);
  if (isOmnibusDataUninitialized || isOmnibusDataLoading) return /*#__PURE__*/_jsx(CallNumberSkeletons, {});
  if (shouldShowCallingDisabled) return /*#__PURE__*/_jsx(GlobalCallingDisabled, {});
  if (!hasPaidSeatAccess()) {
    if (hasCallingMinutesPerPortal()) {
      return /*#__PURE__*/_jsx(View, {
        paddingInline: "400",
        paddingBlock: "250",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "helpdesk.seatRequiredMessage_jsx",
          options: {
            href: KB_URL_MANAGE_SEATS,
            external: true
          },
          elements: {
            UILink: Link
          }
        })
      });
    }
    return /*#__PURE__*/_jsx(UnlockCallingItem, {
      blockingType: "free-account-blocking",
      use: "popover",
      onTrack: handleTracking,
      "data-test-id": "free-account-blocking-popover",
      showIntegrationsLink: false
    });
  }
  return children;
}
CallingOnboardingWorkspace.propTypes = {
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  children: PropTypes.node.isRequired,
  scopes: ImmutablePropTypes.map.isRequired,
  appIdentifier: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(CallingOnboardingWorkspace);